import { IResponse } from "..";
import client from "../client";

export interface ITemplate {
  event: string;
  subject: string;
  type: string;
  content: string;
}

export interface INewTemplate {
  event: string;
  subject: string;
  type: string;
  content: string;
}

export interface IMessage {
  id: string;
  event: string;

  type: string;

  recipientId: string;

  metaData: any;

  content: string;

  subject: string;

  createdAt: Date;

  sentAt: Date;
}

async function addTemplate(comment: INewTemplate) {
  return client.post<IResponse<ITemplate>>(`/messaging/template`, comment);
}

async function getTemplates() {
  return client.get<IResponse<ITemplate[]>>(`/messaging/template`);
}

async function deleteTemplate(id: string, type: string) {
  return client.delete<IResponse<ITemplate>>(
    `/messaging/template/${id}/${type}`
  );
}

async function getMessagesOfUser(userId: string) {
  return client.get<IResponse<IMessage[]>>(`/messaging/message/user:${userId}`);
}

async function getMessage(messageId: string) {
  return client.get<IResponse<IMessage>>(`/messaging/message/${messageId}`);
}

const api = {
  getTemplates,
  addTemplate,
  deleteTemplate,
  getMessagesOfUser,
  getMessage,
};

export default api;
